import { action, observable, toJS, runInAction } from 'mobx'
import { message } from 'hljd'
import { getMerchantInfo } from '@util'
import { APPROVAL_STATUS } from '@components/Hotel/constant'
import Api from '@api/hotel/albumManage'

export default class {
  // 上传的视频
  @observable video = []
  // 待审核和已通过的图片
  @observable
  images = {
    valid: [],
    invalid: []
  }
  // 上传保存中
  @observable
  loading = {
    save: false,
    sort: false
  }
  @observable modalVisible = false
  // 排序的图片
  @observable sortImages = []
  // 正在上传
  @observable isUploading = false

  // 位置：4外观、5大厅、6效果、10视频
  scene = 0
  // 删除的图片id
  deleteIds = []

  constructor(scene) {
    this.scene = scene
  }

  @action
  getAlbum = async (scene = this.scene) => {
    const { data, success } = await Api.getHotelPhotoInfo(scene)
    if (!success) {
      return
    }
    runInAction(() => {
      this.deleteIds = []
    })
    if (!data) {
      return
    }
    runInAction(() => {
      if (data.reason) {
        this.approvalText =
          data.status == APPROVAL_STATUS.WAIT
            ? '审核中！审核结束后，您将收到我们的通知。'
            : `审核未通过，${data.reason}`
      }
    })
    if (!data.photo) {
      return
    }
    runInAction(() => {
      this.images.invalid = data.photo.filter(
        img => img.status == APPROVAL_STATUS.FAIL
      )
      this.images.valid = data.photo.filter(
        img => img.status != APPROVAL_STATUS.FAIL
      )
      this.video = data.video || []
    })
  }

  // 上传视频模态框确定后的回调
  @action
  handleVideoOk = e => {
    // if (this.video && this.video.id) {
    //   this.deleteIds.push(this.video.id)
    // }

    this.video.push({
      persistentId: e.persistent_id,
      videoPath: e.path,
      coverPath: e.cover_path,
      status: APPROVAL_STATUS.WAIT
    })
    this.modalVisible = false
  }

  // 上传视频模态框取消
  @action
  handleVideoCancel = () => {
    this.modalVisible = false
  }

  // 开始排序
  @action
  triggerSort = async () => {
    if (this.sortImages.length !== 0) {
      this.loading.sort = true
      await Api.savePhotoSortInfo({
        merchant_id: getMerchantInfo().id,
        weight_ids: this.sortImages.map(img => img.id)
      })
      runInAction(() => {
        this.loading.sort = false
        const valids = this.images.valid.filter(
          img => img.status != APPROVAL_STATUS.PASS
        )
        this.images.valid = valids.concat(toJS(this.sortImages))
        this.sortImages = []
      })
      return
    }

    this.sortImages = this.images.valid.filter(
      img => img.status == APPROVAL_STATUS.PASS
    )
    if (this.sortImages.length === 0) {
      message.warning('没有通过审核的照片可排序')
      return
    }
  }

  // 删除视频
  @action
  handleVideoDelete = index => () => {
    if (this.video && this.video[index] && this.video[index].id) {
      this.deleteIds.push(this.video[index].id)
    }
    this.video.splice(index, 1)
  }

  // 清除未通过的视频
  clearInvalidImg = () => {
    this.images.invalid.forEach(img => {
      if (img.id) {
        this.deleteIds.push(img.id)
      }
    })

    this.images.invalid = []
  }

  @action
  handleVideoError = (e, info) => {
    if (info.code === -600) {
      message.error('视频大小不能大于100M')
    }
  }

  @action
  triggerVideoModal = () => {
    this.modalVisible = !this.modalVisible
  }

  // 上传图片
  @action
  imageUploaded = (file, url, res) => {
    this.isUploading = false
    this.images.valid.unshift({
      url: url,
      status: APPROVAL_STATUS.WAIT,
      height: res.height,
      width: res.width
    })
  }

  // 上传开始
  imageBeforeUpload = () => {
    this.isUploading = true
  }

  @action
  imageUploadError = (file, up) => {
    this.isUploading = false
    if (up.code === -600) {
      message.error(`${up.file.name}应小于15M`)
    }

    if (up.code === -601) {
      message.error(`请上传JPG、PNG格式的图片`)
    }
  }

  @action
  handleImageDelete = (images, index) => {
    const img = images[index]
    if (img.id) {
      this.deleteIds.push(img.id)
    }
    images.splice(index, 1)
  }

  @action
  sortEnd = (arrayMove, { oldIndex, newIndex }) => {
    this.sortImages = arrayMove(this.sortImages, oldIndex, newIndex)
  }

  @action
  saveAlbum = async () => {
    if (this.video && this.video.status == APPROVAL_STATUS.FAIL) {
      message.warning('请先删除未通过审核的视频')
      return
    }
    if (this.images.invalid.length > 0) {
      message.warning('请先删除未通过审核的图片')
      return
    }
    if (this.images.valid.length > 100) {
      message.warning('每个相册最多添100张照片')
      return
    }
    if (this.images.valid.length === 0 && !this.video) {
      message.warning('请添加图片或视频')
      return
    }

    // 增量保存
    this.loading.save = true
    const photos = this.images.valid.filter(img => !img.id)
    const videos = this.video.filter(item => !item.id)
    const body = {
      scene: String(this.scene),
      merchant_id: getMerchantInfo().id,
      videos: videos.length === 0 ? null : videos,
      photos: photos.length === 0 ? null : photos,
      deleteIds: this.deleteIds.join(',')
    }
    const { success } = await Api.saveHotelPhotoInfo(body)

    if (!success) {
      runInAction(() => {
        this.loading.save = false
      })
      return
    }
    setTimeout(async () => {
      await this.getAlbum()
      runInAction(() => {
        this.loading.save = false
      })
      message.success('保存成功，已提交审核')
    }, 500)
  }
}
